import { ref, Ref } from "vue"

const isDisplayEmailSentMessage: Ref<boolean> = ref(false)
export default isDisplayEmailSentMessage
